
<header>
  <div class="d-flex">
    <fieldmagic-dialog-title
      icon="link"
      class="text-primary"
      label="{{ 'link_' +strListingModule }}"
    ></fieldmagic-dialog-title>
    <div class="ml-auto d-flex">
      <ul class="list-inline pull-right">
        <li class="list-inline-item">
          <button (click)="onLinkRecord()" class="btn ml-1 btn-primary" [disabled]="bSubmitted">
            <fa-icon *ngIf="!bSubmitted" [icon]="['fas', 'link']"></fa-icon>
            <fa-icon *ngIf="bSubmitted" [icon]="['fas', 'spinner']" [spin]="true" aria-hidden="true"></fa-icon>
            <span class="pl-1">{{ 'link' | translate }}</span>
          </button>
        </li>
        <li class="list-inline-item">
          <fieldmagic-primary-button
            (click)="cancelDialog()"
            icon="times"
            variant="error"
            label="close"
            [disabled]="bSubmitted"
          ></fieldmagic-primary-button>
        </li>
      </ul>
    </div>
  </div>
</header>

<hr class="separator"/>

<mat-dialog-content>
<app-error-handler onlyFor="edit_form" [isAction]="true" alignment="center">
<div class="row">
  <div class="col-11">
    <advanced-searchbox
      *ngIf='objAdvancedSearchbox.template'
      (onChange)="triggerFilter($event)"
      [placeholder]="'search'"
      [openOnLoad]="false"
      [template]="objAdvancedSearchbox.template"
      [model]="objAdvancedSearchbox.model"
      [form]="objAdvancedSearchbox.form">
    </advanced-searchbox>
  </div>
  <div class="col-1 pt-7px">
    <button (click)="filterRecord('go')" class="btn btn-primary form-control h-30px">
      <fa-icon [icon]="['fas', 'search']"></fa-icon>
    </button>
  </div>
</div>
<div class="row">
  <div *ngIf="!listingService.bLoading" class="col-12">
    <fc-common-pagination [objPagination]="objPagination" (objNavigate)="onChangePage($event)"></fc-common-pagination>
    <table class="table table-borderless child-table" style="margin-bottom: 0px;">
      <tr class="datarow" *ngFor="let rowData of arData; let recordIndex = index" [id]="'recordDetails' + recordIndex">
        <td class="list-item-outline {{ useFieldWidth }}" style="width: 5%">
          <ng-container *ngIf="rowData.is_linked; else showCheckbox">
            <fa-icon
              [icon]="['fas', 'check-circle']"
              class="text-success fa-lg"
              matTooltip="{{ 'record_already_link_to_parent_record' | translate }}">
            </fa-icon>
          </ng-container>
          <ng-template #showCheckbox>
            <input [attr.id]="'recordCheckbox' + recordIndex"
              type="checkbox"
              [checked]="rowData['is_checked']"
              [name]="rowData['is_checked']"
              (change)="ngOnChangeCheckbox($event, rowData)"
              >
          </ng-template>
        </td>
        <td *ngFor="let strRowDisplay of arRowDisplay"
          class="list-item-outline {{ useFieldWidth }}"
          (click)="redirectToRecordView(rowData.id, recordIndex)"
          [ngClass]="{
            'status-field-style' : checkStatusField(strRowDisplay),
            'short-field-style' : checkShortDisplayField(strRowDisplay),
            'long-field-style' : checkLongDisplayField(strRowDisplay),
            'phone-field-style' : strRowDisplay == 'phone'
          }">

          <app-list id="record{{recordIndex}}"
            [rowType]="arContentType"
            [rowData]="rowData"
            [rowToDisplay]="strRowDisplay"
            [strRecordUrl]="generateRecordUrl(rowData.id, recordIndex)"
            [currentModule]="strListingModule"
            [legends]="objLegends">
          </app-list>
        </td>
        <td>
          <a *ngIf="rowData.is_linked" class="pl-1 pr-1 pb-2 pt-2" target="_blank" (click)="unLinkRecord(rowData.id)">
            <fa-icon
              matTooltipClass="tooltip-space"
              matTooltip="{{ 'unlink_record' | translate }}"
              class="text-warning cursor-pointer"
              [icon]="['fas', 'unlink']">
            </fa-icon>
          </a>
          <a *ngIf="rowData.id" href="/#/{{ strListingModule }}/{{ rowData.id }}" class="pl-1 pr-1 pb-2 pt-2" target="_blank">
            <fa-icon
              matTooltipClass="tooltip-space"
              matTooltip="{{ 'view' | translate }}"
              class="text-primary cursor-pointer"
              [icon]="['fas', 'eye']">
            </fa-icon>
          </a>
        </td>
      </tr>
    </table>
  </div>
</div>
</app-error-handler>
</mat-dialog-content>

